import {
  sendContactMessage,
  getSupportFAQIndex,
} from '@/api/support.api'

const state = {
  supportFAQCollection: []
}

const mutations = {
  pushSupportFAQCollection (state, supportFAQCollection) {
    supportFAQCollection.map(i => state.supportFAQCollection.push(i))
  }
}

const getters = {
  supportFAQCollection ({ supportFAQCollection }) {
    return supportFAQCollection
  },
}

const actions = {
  async sendContactMessage (context, data) {
    return await sendContactMessage(data)
  },

  async fetchSupportFAQCollection ({ commit }) {
    const supportFAQCollection = await getSupportFAQIndex()
    commit('pushSupportFAQCollection', supportFAQCollection)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
